import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";
import { EventBySlugOutput } from "~/types/EventTypesInferred";

type SideBarState = "view" | "edit" | "invisible";

export type PanelStateTypes =
    | "default"
    | "edit"
    | "settings"
    | "badges"
    | "duplicate"
    | "attendees"
    | "hosts"
    | "reminders"
    | "messenger"
    | "share"
    | "flyer"
    | "checkin";

export type EventDetailsRenderState = {
    sideBarState: SideBarState;
    panelMode: PanelStateTypes;
    isSidebarVisible: boolean;
    currentStoreEvent: EventBySlugOutput | null;

    setSideBarState: (mode: SideBarState) => void;
    setPanelMode: (mode: PanelStateTypes) => void;
    setIsSidebarVisible: (_visible: boolean) => void;
    setCurrentStoreEvent: (event: EventBySlugOutput) => void;

    clear: () => void;
};

export const eventDetailsPageStore = (
    set: (state: Partial<EventDetailsRenderState>) => void,
    get: () => EventDetailsRenderState,
): EventDetailsRenderState => ({
    sideBarState: "view",
    panelMode: "default",
    isSidebarVisible: false,
    currentStoreEvent: null,

    setSideBarState: (_sideBarState: SideBarState) => {
        const currentState = get();

        if (currentState.sideBarState !== _sideBarState) {
            set({ ...currentState, sideBarState: _sideBarState });
        }
    },
    setPanelMode: (_panelMode: PanelStateTypes) => {
        const currentState = get();

        if (currentState.panelMode !== _panelMode) {
            set({ ...currentState, panelMode: _panelMode });
        }
    },
    setIsSidebarVisible: (_visible: boolean) => {
        const currentState = get();

        if (currentState.isSidebarVisible !== _visible) {
            set({ ...currentState, isSidebarVisible: _visible });
        }
    },
    setCurrentStoreEvent: (_event: EventBySlugOutput) => {
        const currentState = get();

        set({ ...currentState, currentStoreEvent: _event });
    },

    clear: () => {
        set({
            sideBarState: "view",
            panelMode: "default",
            currentStoreEvent: null,
        });
    },
});
